export default {
  props: {
    total: {
      // 总长度
      type: Number,
      default: 10
    },
    perPage: {
      // 每页长
      type: Number,
      default: 10
    },
    currentPage: {
      // 当前页
      type: Number,
      default: 1
    }
  },
  computed: {
    pages() {
      // 总页数
      return Math.ceil(this.total / this.perPage);
    }
  },
  methods: {
    threeNum() {
      // 三号位页码计算
      let num = 3;
      const currentPage = this.currentPage;
      const pages = this.pages;
      if (currentPage < 3) {
        num = 3;
      } else if (currentPage > pages - 3) {
        num = pages - 2;
      } else {
        num = currentPage;
      }
      return num;
    },
    goPrex() {
      let currentPage = this.currentPage;
      if (currentPage > 1) {
        this.handleEmit(--currentPage);
      }
    },
    goNext() {
      let currentPage = this.currentPage;
      if (currentPage < this.pages) {
        this.handleEmit(++currentPage);
      }
    },
    goIndex(i) {
      if (i !== this.currentPage) {
        this.handleEmit(i);
      }
    },
    handleEmit(i) {
      this.$emit('getCurrentPage', i);
    }
  }
};